import { useTranslation } from 'react-i18next'
import { BriefingGuidanceCollapsible } from '@/shared/briefing/BriefingGuidanceCollapsible'

const GUIDANCE_BASE = 'v2.pages.products.detail.drawings.guidance'

export function V2ProductDrawingsGuidance() {
  const { t } = useTranslation('common')
  const snapshotItems = t(`${GUIDANCE_BASE}.items`, { returnObjects: true })

  return (
    <BriefingGuidanceCollapsible
      idPrefix='product-drawings-guidance'
      title={t(`${GUIDANCE_BASE}.title`)}
      intro={t(`${GUIDANCE_BASE}.intro`)}
      items={Array.isArray(snapshotItems) ? snapshotItems.filter((item) => typeof item === 'string') : []}
    />
  )
}
